import React from 'react';
import withProperProps from 'sis_ui/utils/withProperProps';
import PropTypes from 'prop-types';

import { Accordion, Card } from 'react-bootstrap';

const AccordionBody = (props) => {
    return <Accordion.Collapse eventKey={props.eventKey}>
        <Card.Body>
            {props.children}
        </Card.Body>
    </Accordion.Collapse>
}


AccordionBody.defaultProps = {
    id: "",
}

AccordionBody.propTypes = {
   id: PropTypes.string,
}

AccordionBody.propDescriptions = {
    id: "component id",
}
export default withProperProps(AccordionBody);